// Module-level Map — lives for the browser tab's lifetime.
// Cleared automatically when the tab/window is closed.
const positions = new Map();

export function saveResumePosition(videoId, seconds) {
  if (!videoId || !Number.isFinite(seconds) || seconds <= 0) return;
  positions.set(videoId, seconds);
}

export function getResumePosition(videoId) {
  return positions.get(videoId) || 0;
}

export function clearResumePosition(videoId) {
  positions.delete(videoId);
}

// Keep only video IDs in the allowed set; delete everything else.
// Call this whenever currentIndex changes, passing the ±3 window of IDs.
export function pruneResumeWindow(allowedIds) {
  const allowed = new Set(allowedIds);
  for (const id of positions.keys()) {
    if (!allowed.has(id)) positions.delete(id);
  }
}
